import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

export interface RouteUpdateConfirmationData {
  routeName: string;
}

@Component({
  selector: "app-route-update-confirmation",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="dialog-header">
      <div class="dialog-icon" aria-hidden="true">!</div>
      <div>
        <h2 mat-dialog-title>Actualizar responsable de la ruta</h2>
      </div>
    </div>

    <mat-dialog-content>
      <p>
        Se modificó el usuario o responsable de la ruta
        <strong>{{ data.routeName || 'seleccionada' }}</strong>.
      </p>
      <p>
        ¿Deseas replicar el cambio en los viajes abiertos?
      </p>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-stroked-button type="button" (click)="close(false)">Cancelar</button>
      <button mat-flat-button color="primary" type="button" (click)="close(true)">
        Continuar
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    :host { display: block; min-width: 390px; color: #374151; }
    .dialog-header { display: flex; align-items: center; gap: 12px; padding: 22px 24px 4px; }
    .dialog-icon { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 10px; background: #eef2ff; color: #4f46e5; font-size: 22px; font-weight: 700; }
    h2 { margin: 0 !important; color: #111827 !important; font-size: 18px !important; font-weight: 700 !important; line-height: 1.3 !important; }
    mat-dialog-content { padding: 14px 24px 4px; color: #4b5563; font-size: 14px; line-height: 1.5; }
    mat-dialog-content p { margin: 0 0 12px; }
    mat-dialog-content strong { color: #111827; font-weight: 600; }
    mat-dialog-actions { padding: 10px 24px 20px; gap: 8px; }
    mat-dialog-actions button { min-width: 100px; }
    @media (max-width: 600px) { :host { min-width: auto; } }
  `],
})
export class RouteUpdateConfirmationComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<RouteUpdateConfirmationComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public readonly data: RouteUpdateConfirmationData
  ) {}

  close(result: boolean): void {
    this.dialogRef.close(result);
  }
}
